export default "__VITE_ASSET__BFTBYvRn__"